export default __webpack_public_path__ + "static/pc-carousel-04-6c1a98966929ca08399524a24d5c782f.jpg";